import { useEffect } from 'react';
import {
  createTechDocsAddonExtension,
  TechDocsAddonLocations,
  useShadowRootElements,
  useTechDocsReaderPage,
} from '@backstage/plugin-techdocs-react';
import { replaceWithEntityMetadataValues } from '@appfolio/backstage-plugin-catalog-common';
import { techdocsExtensionPlugin } from '../../plugin';

const NavigationTemplateAddon = () => {
  const context = useTechDocsReaderPage();
  const [label] = useShadowRootElements(['label.md-nav__title']);
  useEffect(() => {
    if (
      !context.entityMetadata.loading &&
      typeof context.entityMetadata.value !== 'undefined' &&
      typeof label !== 'undefined'
    ) {
      label.innerHTML = replaceWithEntityMetadataValues(
        label.innerHTML,
        context.entityMetadata.value.metadata,
      );
    }
  }, [context.entityMetadata.loading, context.entityMetadata.value, label]);
  return null;
};

export const NavigationTemplate = techdocsExtensionPlugin.provide(
  createTechDocsAddonExtension({
    name: 'NavigationTemplate',
    location: TechDocsAddonLocations.PrimarySidebar,
    component: NavigationTemplateAddon,
  }),
);
